/**
 * 会員登録・認証関連のユーティリティ関数
 */

export const MEMBER_PASSWORD_RULE_LABEL = '10文字以上、英字と数字を含む';
export const MEMBER_PASSWORD_RULE_ERROR = 'パスワードは10文字以上で、英字と数字を両方含めてください';

/**
 * clinic_idを生成する（ローマ字2文字＋郵便番号7桁）
 * @param zipcode 郵便番号（7桁、ハイフンなし）
 * @returns clinic_id（例：AB8020015）
 */
export const generateClinicId = (zipcode: string): string => {
  // 郵便番号からハイフンを除去
  const cleanZipcode = zipcode.replace(/-/g, '');
  
  if (cleanZipcode.length !== 7) {
    throw new Error('郵便番号は7桁である必要があります');
  }

  // ランダムなローマ字2文字を生成（A-Z）
  const randomChars = Array.from({ length: 2 }, () => {
    return String.fromCharCode(65 + Math.floor(Math.random() * 26));
  }).join('');

  // clinic_id = ローマ字2文字 + 郵便番号7桁
  return `${randomChars}${cleanZipcode}`;
};

/**
 * 郵便番号のバリデーション
 * @param zipcode 郵便番号
 * @returns バリデーション結果
 */
export const validateZipcode = (zipcode: string): { valid: boolean; error?: string } => {
  const cleanZipcode = zipcode.replace(/-/g, '');
  
  if (!cleanZipcode) {
    return { valid: false, error: '郵便番号を入力してください' };
  }
  
  if (!/^\d{7}$/.test(cleanZipcode)) {
    return { valid: false, error: '郵便番号は7桁の数字である必要があります' };
  }
  
  return { valid: true };
};

/**
 * メールアドレスのバリデーション
 * @param email メールアドレス
 * @returns バリデーション結果
 */
export const validateEmail = (email: string): { valid: boolean; error?: string } => {
  if (!email) {
    return { valid: false, error: 'メールアドレスを入力してください' };
  }
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { valid: false, error: '有効なメールアドレスを入力してください' };
  }
  
  return { valid: true };
};

/**
 * パスワードのバリデーション
 * @param password パスワード
 * @returns バリデーション結果
 */
export const validatePassword = (password: string): { valid: boolean; error?: string } => {
  if (!password) {
    return { valid: false, error: 'パスワードを入力してください' };
  }

  if (password.length < 10) {
    return { valid: false, error: MEMBER_PASSWORD_RULE_ERROR };
  }

  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) {
    return { valid: false, error: MEMBER_PASSWORD_RULE_ERROR };
  }

  return { valid: true };
};

/**
 * リセットトークンを生成する（ランダムな文字列）
 * @returns リセットトークン
 */
export const generateResetToken = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  for (let i = 0; i < 32; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
};

